import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { service, Embed } from 'powerbi-client';
import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';

@Component({
  selector: 'app-ecls-power-bi-report',
  templateUrl: './ecls-power-bi-report.component.html',
  styleUrls: ['./ecls-power-bi-report.component.scss']
})
export class EclsPowerBiReportComponent implements OnInit {

  @Input() powerBiReportVm: IPowerBiReportViewModel;

  constructor() { }

  // Wrapper object to access report properties
  @ViewChild(PowerBIReportEmbedComponent) reportObj!: PowerBIReportEmbedComponent;

  /**
   *
   */
  eventHandlersMap = new Map([
    ['loaded', () => {
      const report = this.reportObj.getReport();
      report.setComponentTitle('Embedded report');
      console.log('Report has loaded');
    },
    ],
    ['rendered', () => console.log('Report has rendered')],
    ['error', (event?: service.ICustomEvent<any>) => {
      if (event) {
        console.error(event.detail);
      }
    },
    ],
    ['visualClicked', () => console.log('visual clicked')],
    ['pageChanged', (event) => console.log(event)],
  ]) as Map<string, (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null>;

  /**
   *
   */
  ngOnInit(): void {
  }

  /**
   * create the View Model for the component
   * @param reportConfig
   * @returns
   */
  public static powerBiReportVm(reportConfig: any): IPowerBiReportViewModel {
    const ret: IPowerBiReportViewModel = {
      reportConfig: reportConfig,
      cssClassName: 'report-container',
      phasedEmbedding: false
    };
    return ret;
  }

}

/**
 * report view model
 */
export interface IPowerBiReportViewModel {
  reportConfig: any;
  cssClassName: string;
  phasedEmbedding: boolean;

}
